// extracted by mini-css-extract-plugin
export default {"warningBox":"warning_warningBox__ERIiF","warningBoxTitle":"warning_warningBoxTitle__0fRSq"};